/* eslint-disable @typescript-eslint/naming-convention */
import type { Func } from "@react-awesome-query-builder/core";

const DAYS_BETWEEN: Func = {
  label: "DAYS BETWEEN",
  returnType: "number",
  jsonLogic: "DAYS_BETWEEN", // This maps to your registered jsonLogic function
  sqlFunc: "DAYS_BETWEEN",   // Optional: for SQL export
  args: {
    date: {
      label: "From Date",
      type: "date",
      valueSources: ["value", "field", 'func'],
    },
    date2: {
      label: "To Date",
      type: "date",
      valueSources: ["value", "field", 'func'],
    },
  },
  formatFunc: (formattedArgs) =>
    `DAYS_BETWEEN(${formattedArgs.date},${formattedArgs.date2})`,
  sqlFormatFunc: (formattedArgs) =>
    `DAYS_BETWEEN(${formattedArgs.date},${formattedArgs.date2})`,
};

export default DAYS_BETWEEN;